import { createFileRoute, redirect } from '@tanstack/react-router';

import { hrefBelow, type PageStaticData } from '@/shared/routing';

// Moved to `/manufacturing/activities/...`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/manufacturing/activity/$')({
    // Only redirects: the target checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    // No `validateSearch`, like the other splats: the target's validator reads the query string.
    beforeLoad: ({ params, location }) => {
        throw redirect({
            href: hrefBelow('/manufacturing/activities', params._splat, location.searchStr),
            replace: true,
        });
    },
});
